<template>
  <div>
    <div>
      <el-form size="small" ref="formRef" label-width="100px">
        <el-form-item label="地图类型" prop="mapType">
          <el-radio-group v-model="mapType" @change="changeMapKey">
            <el-radio label="baidu">百度地图</el-radio>
            <el-radio label="google">谷歌地图</el-radio>
            <el-radio label="amap">高德地图</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地图key" prop="mapKey">
          <el-input v-model="mapKey" placeholder="请输入地图key"></el-input>
        </el-form-item>


        <el-button type="primary" @click="changeMapType">切换地图</el-button>

      </el-form>
    </div>
    <div style="width: 100%;float: left;">
      <div style="width: 100%; height: 500px">
        <KingLongMap ref="klmap" mapId="klmap" @DrawPointCompleted="DrawPointCompleted"
          @DrawPolyLineCompleted="DrawPolyLineCompleted" @DrawRectangleCompleted="DrawRectangleCompleted"
          @DrawPolygonCompleted="DrawPolygonCompleted" @DrawCircleCompleted="DrawCircleCompleted" />
        <!-- <div id="map" style="width: 100%; height: 100%"></div> -->
      </div>
      <div>
        <el-button type="primary" @click="addMarkerClick">添加点</el-button>
        <el-button type="primary" @click="addLineClick">添加线</el-button>
        <el-button type="primary" @click="addPolygonClick">添加多边形</el-button>
        <el-button type="primary" @click="addCircleClick">添加圆</el-button>
        <el-button type="primary" @click="removeMarkerClick">删除标记</el-button>
        <el-button type="primary" @click="drawPointClick">绘制点</el-button>
        <el-button type="primary" @click="drawLineClick">绘制线</el-button>
        <el-button type="primary" @click="drawRectangleClick">绘制矩形</el-button>
        <el-button type="primary" @click="drawPolygonClick">绘制多边形</el-button>
        <el-button type="primary" @click="drawCircleClick">绘制圆</el-button>
      </div>
    </div>

    <div v-if="false" style="width: 50%;float: left;">
      <div style="width: 100%; height: 500px">
        <!-- <KingLongMap ref="klmap01" mapId="klmap01" @DrawPointCompleted="DrawPointCompleted"
          @DrawPolyLineCompleted="DrawPolyLineCompleted" @DrawRectangleCompleted="DrawRectangleCompleted"
          @DrawPolygonCompleted="DrawPolygonCompleted" @DrawCircleCompleted="DrawCircleCompleted" /> -->
        <!-- <KingLongMap ref="klmap01" mapId="klmap01"  /> -->
      </div>
      <!-- <div>
        <el-button type="primary" @click="addMarkerClick">添加点</el-button>
        <el-button type="primary" @click="addLineClick">添加线</el-button>
        <el-button type="primary" @click="addPolygonClick">添加多边形</el-button>
        <el-button type="primary" @click="addCircleClick">添加圆</el-button>
        <el-button type="primary" @click="drawPointClick">绘制点</el-button>
        <el-button type="primary" @click="drawLineClick">绘制线</el-button>
        <el-button type="primary" @click="drawRectangleClick">绘制矩形</el-button>
        <el-button type="primary" @click="drawPolygonClick">绘制多边形</el-button>
        <el-button type="primary" @click="drawCircleClick">绘制圆</el-button>
      </div> -->
    </div>
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";
import { bd09togcj02, gcj02tobd09, wgs84togcj02, gcj02towgs84 } from "@/utils/lnglat"
export default {
  components: { KingLongMap },
  data() {
    return {
      mapType: "baidu",
      mapKey: "gwHUx2BXdkIw9nbsMA0GUAbVY55kYEVx",
    }
  },

  methods: {
    changeMapKey() {
      //修改store中的mapKey
      if (this.mapType == "baidu") {
        this.mapKey = "gwHUx2BXdkIw9nbsMA0GUAbVY55kYEVx";
      } else if (this.mapType == "google") {
        this.mapKey = "AIzaSyB0ycw_zSFU5KZtQbksscehbM4Pwpyelww";
      } else if (this.mapType == "amap") {
        this.mapKey = "bed3f5da8ce2c981f100af6eca3a3e37";
      }
    },
    changeMapType() {
      //修改store中的mapType
      this.$store.commit("app/changeMapType", this.mapType);
      //修改store中的mapKey
      this.$store.commit("app/changeMapKey", this.mapKey);

      //刷新路由
      this.$router.go(0);
      // this.$router.push({ path: this.$route.path });
    },
    DrawCircleCompleted(lng, lat, radius) {
      console.log(lng, lat, radius)
    },
    drawCircleClick() {
      this.$refs.klmap.drawCircle();
    },

    DrawPolygonCompleted(lnglats) {
      console.log(lnglats)
    },
    drawPolygonClick() {
      this.$refs.klmap.drawPolygon();
    },
    DrawRectangleCompleted(sw_lng, sw_lat, ne_lng, ne_lat) {
      console.log(sw_lng, sw_lat, ne_lng, ne_lat);
    },
    drawRectangleClick() {
      this.$refs.klmap.drawRectangle();
    },
    DrawPolyLineCompleted(lnglats) {
      console.log(lnglats); //116.31871013851249,39.872531471741304;116.47798176490944,39.92572926658523;116.49009773808255,39.88965118665674
    },
    drawLineClick() {
      this.$refs.klmap.drawLine();
    },
    DrawPointCompleted(lng, lat) {
      console.log("绘制完成点111")
      console.log(lng, lat);

      this.$refs.klmap.addMarker("s", "s", lng, lat);
    },
    drawPointClick() {
      this.$refs.klmap.drawPoint();
    },
    addCircleClick() {
      var c = { lng: 116.404, lat: 39.915 };

      this.$refs.klmap.addCircle("s_circle", c, 1000);
    },
    addPolygonClick() {
      var coordanites = [];
      coordanites.push({ lng: 118.24143, lat: 24.587076 });
      coordanites.push({ lng: 118.24143, lat: 24.399774 });
      coordanites.push({ lng: 118.055157, lat: 24.399774 });
      coordanites.push({ lng: 118.055157, lat: 24.587076 });
      coordanites.push({ lng: 118.155157, lat: 24.687076 });

      this.$refs.klmap.addPolygon("s_polygon", "s_polygon", coordanites);
    },
    addLineClick() {
      //116.31871013851249,39.872531471741304;116.47798176490944,39.92572926658523;116.49009773808255,39.88965118665674
      var polyline = [
        { lng: 116.31871013851249, lat: 39.872531471741304 },
        { lng: 116.47798176490944, lat: 39.92572926658523 },
        { lng: 116.49009773808255, lat: 39.88965118665674 },
      ];

      this.$refs.klmap.addPolyline("s_line", "s_line", polyline);
    },
    removeMarkerClick() {
      this.$refs.klmap.removeMarkerById("1");
    },
    addMarkerClick() {
      // //办公室
      // this.$refs.klmap.addMarker(
      //   "s",
      //   "s",
      //   117.97144802517361,
      //   24.590943467881946, "assets/svgs/icon_loc_online_0.svg"
      // );
      //阿根廷-->伊朗
       this.$refs.klmap.addMarker(
        "s",
        "s",
        58.44132,        
34.58328, "assets/svgs/icon_loc_online_0.svg"
      );
       this.$refs.klmap.setCenter(58.44132, 34.58328)
      // this.$refs.klmap.addMarker(
      //       "s",
      //       "s",
      //       123.441628,
      //       46.400371
      //     );

      // Latitude
      // : 
      // 24.644648
      // Location
      // : 
      // "福建省厦门市集美区后溪镇新城际广场-一期东北123米"
      // Longitude
      // : 
      // 118.06453
      //故宫 116.3970680093253 39.91751531199665

      //台湾  lat: 23.05459  lon: 120.273609
      // let wgs84 = gcj02towgs84( 120.273609, 23.05459)
      // console.log(wgs84) 
      // // 120.2696
      // //[120.26966005479832, 23.057238373962985]
      // this.$refs.klmap.addMarker(
      //   "1",
      //   "1",
      //  120.26966005479832,
      //   23.057238373962985,
      //   "assets/svgs/icon_loc_online_0.svg", () => {
      //     console.log("回调")
      //   }
      // );

      //117.969880,24.597904,117.977308,24.588762


      // let gcj02 = bd09togcj02( 117.9798891620387, 24.59644765681838)
      // //位置偏移了，变成了百度的经纬度？
      //    this.$refs.klmap.addMarker(
      //   "2",
      //   "2",
      //  gcj02[0],
      //  gcj02[1],
      //   "assets/svgs/icon_loc_online_0.svg",()=>{
      //     console.log("回调")
      //   }
      // );
    },
  },
  mounted() {
    //打印store中的mapType
    console.log(this.$store.state.app.mapType)
    this.mapType = this.$store.state.app.mapType;
    this.mapKey = this.$store.state.app.mapKey;
    //    // 设置坐标类型为WGS84经纬度坐标
    // var map = new BMap.Map("map",{
    //     // coordsType: BMAP_COORDS_WGS84,
    //     coordsType: BMAP_COORD_GCJ02,
    //     // coordsType: BMAP_COORD_BD09 ,
    // });
    /**, {
      coordsType: 5,
    } */
    // console.log(map)
    //     // map.setCoordsType('bd09ll');
    //     // var point = new BMap.Point(117.966798, 24.593905);
    //     var point = new BMap.Point(117.97144802517361, 24.590943467881946);
    //     map.centerAndZoom(point, 15);
    //     var marker = new BMap.Marker(point);
    //     map.addOverlay(marker);
  },
};
</script>
<style scoped></style>
